import {
  GetOrganizationPatientListActionTypes,
  PATIENT_LIST_BY_ORGANIZATION_ID_FAIL,
  PATIENT_LIST_BY_ORGANIZATION_ID_LOADING,
  PATIENT_LIST_BY_ORGANIZATION_ID_SUCCESS,
  PatientListOfOrganizationIdDetailsState,
  ORGANIZATION_PATIENT_LIST_API_MSG,
  ORGANIZATION_PATIENT_LIST_API_RES,
} from "./ActionTypes";
import { GetOrganizationPatientListDetails } from "./Model";

const initialStateGetPosts: PatientListOfOrganizationIdDetailsState = {
  loading: false,
  PatientListOfOrganizationIdRes: {} as GetOrganizationPatientListDetails,
  message: "",
  status: 0,
};
export const getOrganizationPatientReducer = (
  state = initialStateGetPosts,
  action: GetOrganizationPatientListActionTypes
): PatientListOfOrganizationIdDetailsState => {
  switch (action.type) {
    case PATIENT_LIST_BY_ORGANIZATION_ID_LOADING:
      return {
        ...state,
        loading: true,
        PatientListOfOrganizationIdRes:
          {} as GetOrganizationPatientListDetails,
      };
    case PATIENT_LIST_BY_ORGANIZATION_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        PatientListOfOrganizationIdRes: action.payload,
      };
    case PATIENT_LIST_BY_ORGANIZATION_ID_FAIL:
      return {
        ...state,
        loading: false,
        PatientListOfOrganizationIdRes:
          {} as GetOrganizationPatientListDetails,
        message: action.message,
        status: action.status,
      };
    case ORGANIZATION_PATIENT_LIST_API_MSG:
      return {
        ...state,
        loading: false,
        PatientListOfOrganizationIdRes: action.payload,
        message: action.message,
        status: action.status,
      };
    case ORGANIZATION_PATIENT_LIST_API_RES:
      return {
        ...state,
        loading: false,
        PatientListOfOrganizationIdRes:
          {} as GetOrganizationPatientListDetails,
        message: action.message,
        status: action.status,
      };
    default:
      return state;
  }
};
